export default {"src":"/_next/static/media/medical_loan.3e8d1fc2.svg","height":906,"width":767,"blurWidth":0,"blurHeight":0};